import React, {useEffect, useState} from 'react';
import './styles.scss';
import SvgNew from "../components/SvgNew";
import {NavLink, withRouter} from "react-router-dom";
import {compose} from "redux";
import {connect} from "react-redux";
import {getCurrentUserLogin, getRoles} from "../services/userRights";
import {apiGet, stopApiSession} from "../services/apiClient";

const MenuItem = ({entry, history, newStyle}) => {
    const isActiveLink = () => {
        if (entry.isActive) {
            return entry.isActive(history.location, newStyle);
        } else {
            return history.location.pathname === entry.url;
        }
    }

    const label = <div className='open-view'>{(!newStyle && entry.oldLabel) ? entry.oldLabel : entry.label}</div>
    const icon = <SvgNew name={(!newStyle && entry.oldIcon) ? entry.oldIcon : entry.icon}/>

    if ((entry.oldStyleHidden && !newStyle) || (entry.newStyleHidden && newStyle)) return null;

    if (entry.roles) {
        let isView = false;
        let userRoles = getRoles();
        userRoles.forEach((userRole) => {
            if (entry.roles.includes(userRole)) {
                isView = true;
            }
        });
        if (!isView) return null;
    }

    let outerClassName = isActiveLink() ? "active" : "";

    const isBtn = entry.type === 'btn';

    if (entry.type === 'file' || isBtn) {
        return <li className={outerClassName}>
            <a onClick={isBtn ? entry.url : null} href={!isBtn ? entry.url : null} target='_blank'>
                {icon}
                {label}
            </a>
        </li>
    }

    return <li className={outerClassName}>
        <NavLink to={entry.url}>
            {icon}
            {label}
        </NavLink>
    </li>
}

const Menu = ({history}) => {
    const isParcelsLink = (location, newStyle) => {
        let isNewParcel = location.pathname.startsWith('/parcels/new');
        let isListOldStyle = location.pathname.endsWith('/parcels/list') && newStyle;
        let isParcels = location.pathname.startsWith('/parcels/');
        return isParcels && !isNewParcel && !isListOldStyle;
    }

    let menuItemsInit = [
        {
            url: '/parcels/new',
            label: 'Создать отправление',
            icon: 'create-new',
            isActive: (location) => {
                return location.pathname.startsWith('/parcels/new');
            },
            roles: ['Author', 'Coordinator']
        },
        {
            url: '/parcels/list/new',
            label: 'Мои отправления',
            icon: 'box',
            isActive: (location, newStyle) => isParcelsLink(location, newStyle),
            oldStyleHidden: true
        },
        {
            url: '/parcels/list',
            label: 'Посылки',
            icon: 'box',
            isActive: (location, newStyle) => {
                let isListOldStyle = location.pathname.endsWith('/parcels/list');
                return newStyle ? isListOldStyle : isParcelsLink(location, newStyle);
            },
            newStyleHidden: true
        },
        {
            url: '/reports/my',
            label: 'Мои отчеты',
            icon: 'table-report',
            isActive: (location) => {
                return location.pathname.startsWith('/reports/my');
            },
            oldStyleHidden: true
        },
        {
            url: '/dictionary/myaddresses',
            label: 'Мои адреса',
            icon: 'my-addresses',
            isActive: (location) => {
                return location.pathname.startsWith('/dictionary/myaddresses');
            },
        },
        {
            url: '/borderInsurance',
            label: 'Бордеро страхования',
            icon: 'border-insurance',
            isActive: (location) => {
                return location.pathname.startsWith('/borderInsurance')
            },
            roles: ['Coordinator']
        },
        {
            url: '/admin/companies/list',
            label: 'Юр. лица клиентов',
            icon: 'company-client',
            isActive: (location) => {
                return location.pathname.startsWith('/admin/companies/')
            },
            roles: ['Coordinator', 'Admin', 'GlobalAdmin']
        },
        {
            url: '/admin/users/list',
            label: 'Пользователи',
            icon: 'users',
            isActive: (location) => {
                return location.pathname.startsWith('/admin/users/')
            },
            roles: ['Coordinator', 'Admin', 'GlobalAdmin', 'ClientAdmin']
        },
        {
            url: '/admin/rates/list',
            label: 'Коэффициенты',
            icon: 'rates',
            isActive: (location) => {
                return location.pathname.startsWith('/admin/rates/')
            },
            roles: ['Coordinator', 'Admin', 'GlobalAdmin']
        },
        {
            url: '/admin/stats',
            label: 'Статистика',
            icon: 'stats',
            isActive: (location) => {
                return location.pathname.startsWith('/admin/stats')
            },
            roles: ['Coordinator', 'Admin', 'GlobalAdmin']
        },
        // {
        //     url: '',
        //     label: 'Инструкции пользователя',
        //     icon: 'instruction',
        //     type: 'file'
        // }
    ];
    const [menuItems, setMenuItems] = useState(menuItemsInit);
    const [newStyle, setNewStyle] = useState(false);

    useEffect(() => {
        apiGet('user/company')
            .then(data => {
                if (data && data.publicOfferUrl) {
                    setMenuItems(menuItems => ([
                        ...menuItems,
                        {
                            url: data.publicOfferUrl,
                            label: 'Пользовательское соглашение',
                            icon: 'info',
                            type: 'file'
                        }
                    ]))
                }
                if (data) {
                    setNewStyle(data.showNewParcelForm);
                } else {
                    setNewStyle(true);
                }
            });
    }, [])

    const [roleNames, setRoleNames] = useState('');

    const getAllRoles = () => {
        apiGet('ref/roles/list')
            .then(data => {
                setRoleNames(getRoles().map(r => ((data.entries || []).find(rn => rn.name === r) || {}).displayName).join(', '))
            })
            .catch(err => {
                console.log(err)
            });
    }

    useEffect(() => {
        getRoles() && getAllRoles();
    }, [])

    return (
        <div className='new-menu'>
            <div className='new-menu__data'>
                <div className='new-menu__logo' onClick={() => history.push('/')}>
                    <SvgNew name='po-ex-logo'/>
                </div>
                <section className='new-menu__links'>
                    {
                        menuItems.map(item => (
                            <MenuItem key={item.url} entry={item} history={history} newStyle={newStyle}/>
                        ))
                    }
                </section>
            </div>

            <section className='new-menu__user'>
                <div className='new-menu__user-info open-view'>
                    <div className='new-menu__login'>{getCurrentUserLogin()}</div>
                    <div className='new-menu__roles'>{roleNames}</div>
                </div>
                <section className='new-menu__links without-line'>
                    <MenuItem
                        entry={{
                            url: () => stopApiSession(),
                            label: 'Выйти',
                            icon: 'exit',
                            type: 'btn'
                        }}
                        history={history}
                    />
                </section>
            </section>
        </div>
    );
};

export default compose(
    withRouter,
    connect()
)(Menu);


// WEBPACK FOOTER //
// ./App/menu/menu_v2.jsx